import React, { useMemo, cloneElement, isValidElement } from 'react';
import classNames from 'classnames';
//* Components
import Form from '..';
import Input from '../../input';
import Checkbox from '../../checkbox';
import Radio from '../../radio';
import Select from '../../select';
import Upload from '../../upload';
import DatePicker from '../../date-picker';
import ColorPicker from '../../color-picker';
//* Style
import BuilderStyle from './style';
const formElements = {
    'input': React.createElement(Input, null),
    'password': React.createElement(Input.Password, null),
    'textarea': React.createElement(Input.TextArea, null),
    'number': React.createElement(Input.Number, null),
    'phone': React.createElement(Input.PhoneNumber, null),
    'checkbox': React.createElement(Checkbox, null),
    'radio': React.createElement(Radio, null),
    'select': React.createElement(Select, null),
    'upload': React.createElement(Upload, null),
    'date': React.createElement(DatePicker, null),
    'color': React.createElement(ColorPicker, null),
};
const FormBuilder = ({ className = '', onSubmit, formOptions = {}, fields = [], children }) => {
    const elements = useMemo(() => {
        return fields.map((field, index) => {
            if (field.fieldType == 'empty') {
                return (React.createElement("div", { key: index, className: 'empty-form-item', ...field.fieldProps }));
            }
            else if (field.fieldType == 'custom') {
                return isValidElement(field.field)
                    ? cloneElement(field.field, { key: index, ...field.fieldProps })
                    : null;
            }
            else {
                return isValidElement(formElements[field.fieldType]) ? (React.createElement(Form.Item, { key: index, ...field.labelProps }, cloneElement(formElements[field.fieldType], field.fieldProps))) : null;
            }
        });
    }, [fields]);
    const classString = classNames('form-builder', {
        [className]: className,
    });
    return (React.createElement(Form, { ...formOptions, onSubmit: onSubmit },
        React.createElement(BuilderStyle, { className: classString }, elements),
        children));
};
export default FormBuilder;
//# sourceMappingURL=index.js.map